import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Memoized block component for optimized rendering in virtual scrolling
 */
import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
/**
 * Memoized wall block component to prevent unnecessary re-renders
 */
export const WallBlock = React.memo(({ block, segment, calculation, zoom, blockImage, segmentIndex, blockIndex }) => {
    var _a;
    const { t } = useTranslation();
    // Early return if required props are missing
    if (!block || !segment || !calculation) {
        return null;
    }
    // Determine CSS classes for different stone types
    const getBlockClasses = () => {
        const classes = ['block-item'];
        if (block.isTopCornerStone)
            classes.push('top-corner-stone');
        else if (block.isCorner)
            classes.push('corner');
        else if (block.isTopStone)
            classes.push('top-stone');
        else if (block.isStartingStone)
            classes.push('starting-stone');
        else if (block.isEndingStone)
            classes.push('end-stone');
        return classes.join(' ');
    };
    // Compute per-block height in pixels: top stones and top-corner stones can be thinner
    const topStonePx = calculation.selectedTopStone && segment.topStoneHeight ? Math.ceil(segment.topStoneHeight * (zoom / 100)) : undefined;
    const topCornerPx = ((_a = calculation.selectedTopCornerStone) === null || _a === void 0 ? void 0 : _a.variant.thickness)
        ? Math.ceil(calculation.selectedTopCornerStone.variant.thickness * (zoom / 100))
        : topStonePx;
    const perBlockHeight = block.isTopStone ? topStonePx : block.isTopCornerStone ? topCornerPx : undefined;
    return (_jsx("div", Object.assign({ className: getBlockClasses(), 
        // eslint-disable-next-line react/forbid-dom-props
        style: Object.assign({ left: `${block.x}px`, top: `${block.y}px` }, (perBlockHeight ? { height: `${perBlockHeight}px` } : {})) }, { children: blockImage ? (_jsx("div", { className: 'block-image-container', 
            // eslint-disable-next-line react/forbid-dom-props
            style: perBlockHeight ? { height: `${perBlockHeight}px` } : undefined })) : (_jsx("div", Object.assign({ className: 'block-fallback' }, { children: _jsx("span", Object.assign({ className: 'block-text' }, { children: block.isCorner
                    ? t('wall_preview', 'corner')
                    : block.isTopStone
                        ? t('wall_preview', 'top')
                        : block.isStartingStone
                            ? t('wall_preview', 'start')
                            : block.isEndingStone
                                ? t('wall_preview', 'end')
                                : block.isTopCornerStone
                                    ? t('wall_preview', 'top_corner')
                                    : t('wall_preview', 'block') })) }))) }), `${block.blockId}-${blockIndex}`));
});
WallBlock.displayName = 'WallBlock';
